import React from "react";
import { Tabel, DropDown, DropDownMenu, Modal, FilterWraper } from "../core";
import { useSelector } from "react-redux";
import { reducer, initialState } from "../hooks/modalReducer";
import DeleteModal from "../components/DeleteModal";
import { Menu, Form } from "antd";
import EditInvoice from "./EditInvoice";
import { Link } from "react-router-dom";
import {
  getInvoiceWithCompanyId,
  deleteInvoice as deleteInvoiceApi,
} from "../helper/utils/api/invoice";
import { mapInvoicesForList } from "../helper/utils/invoiceMap";
import { getCompanyId } from "../helper/utils/companyId";
const CHANGE_DATE_FORMAT = require("../helper/utils/datFormat");

const baseInvoiceColumns = [
  {
    title: "SR #",
    dataIndex: "SNo",
    key: "S.No",
    width: 150,
    render: (text, record, index) => <span>{index + 1}</span>,
  },
  {
    title: "Dated",
    dataIndex: "invoice_date",
    key: "invoice_date",
    render: (text, record, index) => {
      return (
        <span>
          {/* {record.invoice_date}
          <br /> */}
          {CHANGE_DATE_FORMAT.changeDateFormat(record.invoice_date)}
        </span>
      );
    },
    width: 150,
  },
  {
    title: "Invoice No",
    dataIndex: "invoice_no",
    key: "invoice_no",
    width: 150,
  },
  {
    title: "Description",
    dataIndex: "invoice_note",
    key: "invoice_note",
    width: 150,
  },
  {
    title: "Qty",
    dataIndex: "net_pass_quantity",
    key: "net_pass_quantity",
    width: 150,
  },
  {
    title: "Excel S.Tax",
    dataIndex: "total_price_without_sale_tax",
    key: "total_price_without_sale_tax",
    width: 150,
  },
  {
    title: "Sales Tax Amnt",
    dataIndex: "total_sale_tax_payable",
    key: "total_sale_tax_payable",
    width: 150,
  },
  {
    title: "Value Incl.",
    dataIndex: "total_value_include_sale_tax",
    key: "total_value_include_sale_tax",
    width: 150,
  },
  {
    title: "Name of Parties to whom application made",
    width: 250,
    render: ({ buyer_company_name, address, strn, ntn }) => {
      // const state = useSelector(state => state.state)
      return (
        <span>
          {buyer_company_name} {address}. NTN: {ntn} STRN: {strn}
        </span>
      );
    },
  },
];

const InvoiceList = ({ invoices: invoicesProp, onRefresh }) => {
  const reduxInvoices = useSelector(
    (state) => state.contractReducer?.invoices || []
  );
  const [saleRecord, setSaleRecord] = React.useState([]);
  const [allInvoices, setAllInvoices] = React.useState([]);

  const loadInvoices = React.useCallback(async () => {
    if (invoicesProp) {
      const mapped = mapInvoicesForList(invoicesProp);
      setAllInvoices(mapped);
      setSaleRecord(mapped);
      return;
    }
    const companyId = getCompanyId();
    if (!companyId) return;
    try {
      const { data } = await getInvoiceWithCompanyId({ companyId, limit: 500 });
      const list = mapInvoicesForList(data?.result || data || []);
      setAllInvoices(list);
      setSaleRecord(list);
    } catch (error) {
      const fallback = mapInvoicesForList(reduxInvoices);
      setAllInvoices(fallback);
      setSaleRecord(fallback);
    }
  }, [invoicesProp, reduxInvoices]);

  React.useEffect(() => {
    loadInvoices();
  }, [loadInvoices]);

  const invoiceColumns = React.useMemo(
    () => [
      ...baseInvoiceColumns,
      {
        title: "Action",
        dataIndex: "action",
        width: 150,
        render: (text, record, index) => (
          <DropDown
            overlay={
              <MenuCompo
                index={index}
                record={record}
                onDeleted={loadInvoices}
              />
            }
            record={record}
          />
        ),
      },
    ],
    [loadInvoices]
  );

  const changeInput = (e) => {
    let buyerName = e.target.value;
    const filteredArrayByBuyer = allInvoices.filter((record) => {
      return String(record.invoice_no || "").indexOf(buyerName) > -1;
    });
    setSaleRecord(filteredArrayByBuyer);
  };
  return (
    <FilterWraper
      // rangeFilter={dateRange}

      placeholder="Invoice Number"
      inpputChange={changeInput}
      dropDown={false}
      range={false}
    >
      <Tabel nowidth={false} columns={invoiceColumns} data={saleRecord || []} />
    </FilterWraper>
  );
};

const MenuCompo = ({ record, onDeleted }) => {
  const [form] = Form.useForm();
  const [inoiceId, setInvoiceId] = React.useState(null);
  const [state, dispatch] = React.useReducer(reducer, initialState);

  const onCreate = () => {
    dispatch({ type: "MODAL_VIEW", payload: false });
  };
  const onCancel = () => {
    dispatch({ type: "MODAL_VIEW", payload: false });
  };
  const menuClick = ({ item, key }) => {
    setInvoiceId({ id: item.props.id });
    return key === "delete_invoice"
      ? dispatch({
          type: "MODAL_VIEW",
          payload: { flag: true, modal_name: key },
        })
      : key === "edit_invoice"
      ? dispatch({
          type: "MODAL_VIEW",
          payload: { flag: true, modal_name: key },
        })
      : null;
  };

  const delete_func = async () => {
    const companyId = getCompanyId();
    try {
      await deleteInvoiceApi(
        inoiceId.id,
        companyId || record.company_id
      );
      if (onDeleted) onDeleted();
      onCancel();
    } catch (error) {
      console.log("delete invoice error", error);
    }
  };
  return (
    <>
      {state.modal_name === "delete_invoice" ? (
        <Modal
          closable={true}
          footer={false}
          visible={state.visible}
          maxwidth="550px"
          tittle="Are You Sure you want to delete this Invoice"
        >
          <DeleteModal
            id_to_delete={inoiceId}
            onCancel={onCancel}
            delete_func={delete_func}
          />
        </Modal>
      ) : state.modal_name === "edit_invoice" ? (
        <Modal
          closable={true}
          footer={false}
          visible={state.visible}
          onCreate={onCreate}
          tittle="Edit Invoice"
        >
          <EditInvoice
            inoiceId={inoiceId}
            onCreate={onCreate}
            onCancel={onCancel}
            form={form}
          />
        </Modal>
      ) : null}
      <DropDownMenu onClick={menuClick}>
        <Menu.Item key="delete_invoice" id={record.invoice_id}>
          Delete Invoice
        </Menu.Item>
        <Menu.Item key="edit_invoice" id={record.invoice_id}>
          Edit Invoice
        </Menu.Item>
        <Menu.Item>
          <Link to={`/invoice-inner/${record.invoice_id}`}>View Invoice</Link>
        </Menu.Item>
        <Menu.Item>
          <Link to={`/print-invoice/${record.cloth_return_id}`}>
            Print Invoice
          </Link>
        </Menu.Item>
      </DropDownMenu>
    </>
  );
};
export default InvoiceList;
